import { render, staticRenderFns } from "./calculateprice.vue?vue&type=template&id=1789bbc5&"
import script from "./calculateprice.vue?vue&type=script&lang=ts&"
export * from "./calculateprice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "calculateprice.vue"
export default component.exports